import React from 'react';
import { 
  Server, Shield, Terminal, Plus, Trash2, LogOut, 
  Activity, Lock, Unlock, RefreshCw, Cpu, HardDrive, 
  Wifi, Search, CheckCircle, XCircle, AlertTriangle, Database,
  Folder, FileText, Upload, Download, MoreVertical, ArrowLeft,
  FileCode, FileImage, Home, Play, Square, Settings, FileSearch,
  LayoutDashboard, Info, Users, UserPlus, UserX, Monitor, Power, PlayCircle, StopCircle, Command,
  Edit, Save, X
} from 'lucide-react';

export const Icons = {
  Server, Shield, Terminal, Plus, Trash2, LogOut, 
  Activity, Lock, Unlock, RefreshCw, Cpu, HardDrive, 
  Wifi, Search, CheckCircle, XCircle, AlertTriangle, Database,
  Folder, FileText, Upload, Download, MoreVertical, ArrowLeft,
  FileCode, FileImage, Home, Play, Square, Settings, FileSearch,
  LayoutDashboard, Info, Users, UserPlus, UserX, Monitor, Power, PlayCircle, StopCircle, Command,
  Edit, Save, X
};